import {Component, OnInit, OnDestroy, ViewChild, ElementRef} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import {DomSanitizer} from '@angular/platform-browser';
import {ItemPopupService} from './item-popup.service';
import {ItemService} from './item.service';
import {PopupService} from '../../shared/services/popup/popup.service';
import { Router } from '@angular/router';
import * as _ from 'lodash';
import { ItemPreviewInvoiceTemplateComponent } from '.';
import {PopupService as CommonPopupService} from './../../shared/services/popup/popup.service';


@Component({
	selector: 'jhi-invoice-release-delete-popup',
	template: ''
})
export class ItemPreviewPopupComponent implements OnInit, OnDestroy {
	routeSub: any;
	itemDetails: any;
	constructor(private route: ActivatedRoute,
				private itemPopupService: ItemPopupService,
				
				private commonitemPopupService: CommonPopupService,
				) {
	}

	ngOnInit() {
		this.routeSub = this.route.params.subscribe((params) => {
			this.itemPopupService.setIsViewSample(false);
			//this.itemPopupService.open(ItemPreviewInvoiceTemplateComponent as Component, params['id']);

			this.commonitemPopupService.openComponent(ItemPreviewInvoiceTemplateComponent as Component, params);

		});
	}
	ngOnDestroy() {
		this.routeSub.unsubscribe();
	}
}
